import React, { useState, useEffect, useRef } from 'react';
import { AlertCircle, CheckCircle } from 'lucide-react';
import { authApi } from '../services/api';
import { theme } from '../styles/theme';

function ActivatePage({ onNavigate, token }) {
  // 'pending' | 'success' | 'error'
  const [status, setStatus] = useState('pending');
  const [message, setMessage] = useState('');
  // Le token est à usage unique : éviter le double appel (React StrictMode rejoue les effets en dev)
  const activated = useRef(false);

  useEffect(() => {
    if (!token) {
      setStatus('error');
      setMessage('Le lien d\'activation est invalide ou a expiré.');
      return;
    }
    if (activated.current) return;
    activated.current = true;
    authApi.activateAccount(token)
      .then(() => setStatus('success'))
      .catch((error) => {
        setStatus('error');
        setMessage(error.message || 'Le lien d\'activation est invalide ou a expiré.');
      });
  }, [token]);

  const Card = ({ children }) => (
    <div className={theme.classes.page + " flex items-center justify-center p-4"}>
      <div className="max-w-md w-full text-center">
        <div className={theme.classes.card.default + " shadow-xl p-8"}>{children}</div>
      </div>
    </div>
  );

  if (status === 'pending') {
    return (
      <Card>
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-yellow-500 mx-auto mb-4"></div>
        <p className="text-gray-400">Activation de votre compte...</p>
      </Card>
    );
  }

  if (status === 'success') {
    return (
      <Card>
        <div className="bg-green-500/20 p-4 rounded-full w-fit mx-auto mb-4">
          <CheckCircle className="h-12 w-12 text-green-400" />
        </div>
        <h1 className="text-2xl font-bold text-white mb-4">Compte activé !</h1>
        <p className="text-gray-400 mb-6">
          Votre compte est maintenant actif. Vous pouvez vous connecter.
        </p>
        <button
          onClick={() => onNavigate('login')}
          className="px-6 py-2 bg-yellow-500 text-black rounded-lg
                     hover:bg-yellow-400 transition-colors font-medium"
        >
          Se connecter
        </button>
      </Card>
    );
  }

  return (
    <Card>
      <AlertCircle className="h-16 w-16 text-red-400 mx-auto mb-4" />
      <h1 className="text-2xl font-bold text-white mb-4">Activation impossible</h1>
      <p className="text-gray-400 mb-6">{message}</p>
      <button
        onClick={() => onNavigate('login')}
        className="px-6 py-2 bg-yellow-500 text-black rounded-lg
                   hover:bg-yellow-400 transition-colors font-medium"
      >
        Retour à la connexion
      </button>
    </Card>
  );
}

export default ActivatePage;
